export const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const cities = [
  "Ahmedabad",
  "Bangalore",
  "Bhopal",
  "Chennai",
  "Delhi",
  "Hyderabad",
  "Indore",
  "Jaipur",
  "Kanpur",
  "Kolkata",
  "Lucknow",
  "Mumbai",
  "Nagpur",
  "Noida",
  "Patna",
  "Pune",
  "Surat",
  "Thane",
  "Vadodara",
  "Visakhapatnam",
];

export const filters = [
  "Sleeper",
  "Seater",
  "AC",
  "Non-AC",
  "Wi-Fi",
  "Charger",
  "Movies",
];

export const sorters = ["Price"];
